import React from 'react';
import './styles.scss';

const LoadingSpinner = () => {
    return (
        <div className="loadingSpinner">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '3rem' }}></i>
        </div>
    );
};

export default LoadingSpinner;
